var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "producer-logo-container",
        staticStyle: { height: "20px" }
      },
      [_c("img", { attrs: { src: _vm.getLogoName, alt: _vm.getLogoName } })]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "table-cell",
        staticStyle: { width: "100px", height: "20px" }
      },
      [_vm._v(_vm._s(_vm.getI18n(_vm.observation.producer.name, "en")))]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "table-cell",
        staticStyle: { width: "150px", height: "20px" }
      },
      [
        _vm.observation.observation.featureOfInterest.samplingFeature.name !=
        null
          ? _c("div", [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.getI18n(
                      _vm.observation.observation.featureOfInterest
                        .samplingFeature.name,
                      "en"
                    )
                  ) +
                  "\n    "
              )
            ])
          : _vm._e()
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "table-cell",
        staticStyle: { width: "175px", height: "20px" }
      },
      [
        _vm._v(
          _vm._s(_vm.getI18n(_vm.observation.dataset.metadata.title, "en"))
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "table-cell",
        staticStyle: { width: "350px", height: "20px" }
      },
      [
        _vm._v(
          "\n    " +
            _vm._s(
              _vm.getI18n(
                _vm.observation.observation.observedProperty.name,
                "en"
              )
            ) +
            "\n    (" +
            _vm._s(
              _vm.getI18n(
                _vm.observation.observation.observedProperty.unit,
                "en"
              )
            ) +
            ")"
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "show-detail ui button",
        on: {
          click: function($event) {
            $event.stopPropagation()
            return _vm.showDetails($event)
          }
        }
      },
      [_c("i", { staticClass: "info icon" }), _vm._v(" Show details\n  ")]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }